// StepStructure — placeholder for Phase 5 step 2.
// V1 captures only legal_structure + industry. Full builder lands in
// a follow-up iteration (Option 🅱 in the user's queue).
import React, { useState, useEffect } from 'react';
import { Button } from '../../../components/ui/button';
import { Layers, ChevronRight } from 'lucide-react';

const LEGAL_STRUCTURES = [
  { id: 'llc',         label: 'Limited Liability Company (LLC)' },
  { id: 'jsc',         label: 'Joint Stock Company (JSC)' },
  { id: 'sole',        label: 'Sole proprietorship' },
  { id: 'partnership', label: 'Partnership' },
  { id: 'other',       label: 'Other' },
];

const INDUSTRIES = [
  'Contracting · General',
  'Contracting · Electromechanical',
  'Contracting · Civil',
  'Trading',
  'Manufacturing',
  'Services',
];

export default function StepStructure({ initialData, onSubmit, busy }) {
  const [form, setForm] = useState({ legal_structure: 'llc', industry: 'Contracting · General' });

  useEffect(() => {
    if (initialData) {
      const h = setTimeout(() => setForm((f) => ({ ...f, ...initialData })), 0);
      return () => clearTimeout(h);
    }
  }, [initialData]);

  return (
    <div data-testid="step-structure" className="space-y-5">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-lg bg-indigo-50 text-indigo-700"><Layers size={18} /></div>
        <div>
          <h2 className="text-lg font-bold text-slate-900">Legal structure & industry</h2>
          <p className="text-sm text-slate-500 mt-0.5">Drives default chart-of-accounts and compliance templates.</p>
        </div>
      </div>

      <div>
        <label className="text-xs font-medium text-slate-500 mb-2 block">Legal structure</label>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-testid="structure-options">
          {LEGAL_STRUCTURES.map((s) => (
            <button
              type="button"
              key={s.id}
              data-testid={`structure-opt-${s.id}`}
              onClick={() => setForm((f) => ({ ...f, legal_structure: s.id }))}
              className={`px-4 py-3 rounded-lg border text-sm text-left transition ${
                form.legal_structure === s.id
                  ? 'border-indigo-500 bg-indigo-50 text-indigo-800 font-semibold'
                  : 'border-slate-200 hover:border-slate-300 bg-white'
              }`}
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>

      <div>
        <label className="text-xs font-medium text-slate-500 mb-2 block">Industry</label>
        <select
          data-testid="structure-industry"
          value={form.industry}
          onChange={(e) => setForm((f) => ({ ...f, industry: e.target.value }))}
          className="w-full px-3 py-2 rounded-md border border-slate-200 bg-white text-sm"
        >
          {INDUSTRIES.map((i) => <option key={i} value={i}>{i}</option>)}
        </select>
      </div>

      <div className="flex justify-end">
        <Button
          onClick={() => onSubmit(form)}
          disabled={busy}
          data-testid="structure-save-btn"
          className="bg-indigo-600 hover:bg-indigo-700 text-white"
        >
          Save & continue <ChevronRight size={14} className="ml-1.5" />
        </Button>
      </div>
    </div>
  );
}
